<div class="p-4 w-full flex flex-col pt-12">
  <!-- Botón Volver con SVG manual para asegurar dirección < -->
  <div class="mb-4">
    <button (click)="goBack()"
      class="w-10 h-10 flex items-center justify-center hover:bg-gray-100 rounded-full transition-all text-gray-600">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M5 12l14 0" />
        <path d="M5 12l4 4" />
        <path d="M5 12l4 -4" />
      </svg>
    </button>
  </div>

  @if (isLoading) {
  <div class="flex justify-center py-20">
    <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-metro-blue"></div>
  </div>
  } @else if (client) {
  <!-- Tarjeta posicionada más arriba con pt-12 -->
  <div
    class="flex flex-col md:flex-row items-center justify-between gap-6 bg-white p-6 md:p-12 rounded-xl shadow-sm border border-gray-100 w-full min-h-[180px]">

    <!-- Info Cliente (Avatar + Nombre centrado y más cerca) -->
    <div class="flex flex-col md:flex-row items-center gap-3">
      <div
        class="w-20 h-20 md:w-16 md:h-16 bg-slate-700 text-white rounded-full flex items-center justify-center text-3xl md:text-2xl font-bold shadow-sm flex-shrink-0">
        {{ client.clientName[0] }}{{ client.clientSurname[0] }}
      </div>
      <div class="flex flex-col items-center md:items-start justify-center text-center md:text-left">
        <h1 class="text-2xl font-bold text-gray-900 leading-tight m-0">
          {{ client.clientName }} {{ client.clientSurname }}
        </h1>
        @if (client.phoneNumber) {
        <p class="text-gray-400 font-medium mt-1 mb-0 text-sm">{{ client.phoneNumber }}</p>
        }
      </div>
    </div>

    <!-- Botón de Acción -->
    <div class="flex-shrink-0 w-full sm:w-4/5 md:w-auto flex justify-center">
      <app-metro-button variant="primary" [fullWidth]="true" [text]="'::ManageCart' | abpLocalization" [icon]="iconCart"
        iconSize="18" iconColor="white" (clicked)="manageCart()">
      </app-metro-button>
    </div>
  </div>

  <!-- Historial de Órdenes -->
  <div class="mt-8">
    <h3 class="text-lg font-bold text-gray-700 mb-4">Historial de Órdenes</h3>

    @if (isLoadingOrders) {
    <div class="flex justify-center py-10">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-metro-blue"></div>
    </div>
    } @else if (clientOrders.length === 0) {
    <p class="text-gray-500 text-sm py-4">No hay órdenes para este cliente.</p>
    } @else {
    <div class="flex flex-col gap-2 pb-20">
      @for (order of clientOrders; track (order.isCart ? 'cart-' : 'order-') + order.id) {
      <div (click)="viewOrder(order)" class="bg-white rounded-xl p-2 flex justify-between items-center shadow-sm border border-gray-100 cursor-pointer hover:bg-gray-50 transition-colors">
        <div class="flex flex-col">
          <div class="flex items-center gap-2 sm:gap-3 mb-1">
            @if (order.isCart) {
            <span class="text-xs font-bold text-gray-600 uppercase">CARRITO ACTUAL</span>
            <span
              class="text-[10px] font-bold px-2 py-0.5 rounded-full {{ getStatusClass(order.orderStatus) }} uppercase whitespace-nowrap">
              EN CARRITO
            </span>
            } @else {
            <span class="text-xs font-bold text-gray-600 uppercase">ORDEN #{{order.id}}</span>
            <span
              class="text-[10px] font-bold px-2 py-0.5 rounded-full {{ getStatusClass(order.orderStatus) }} uppercase whitespace-nowrap">
              {{ getStatusLabel(order.orderStatus) | abpLocalization }}
            </span>
            }
          </div>
          <span class="text-[15px] font-semibold text-gray-900">{{ formatDate(order.creationTime) }}</span>
        </div>
        <div>
          <span class="text-lg font-bold text-gray-900">{{ formatCurrency(order.total) }}</span>
        </div>
      </div>
      }
    </div>
    }
  </div>

  } @else {
  <div class="text-center py-20 bg-gray-50 rounded-2xl border-2 border-dashed border-gray-200 w-full max-w-2xl mx-auto">
    <p class="text-gray-500 font-medium">{{ '::ClientNotFound' | abpLocalization }}</p>
    <button (click)="goBack()" class="mt-4 text-metro-blue font-bold hover:underline">
      {{ '::GoBack' | abpLocalization }}
    </button>
  </div>
  }
</div>